import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  useMediaQuery,
  MenuItem,
  TextField,
  Typography,
  styled,
  CircularProgress,
} from '@mui/material'
import ErrorIcon from '@mui/icons-material/Error'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import { useEffect, useState } from 'react'
import { isValidEmail, isValidPhoneNumber, isValidUrl } from '../../libs/utils'
import { getZipCodes, states, whichStates } from './utils'

export const StyledTextField = styled(TextField)({
  width: '100%',
  backgroundColor: 'white',
  fontSize: '16px',
})

const ThirdRegisterStepV2 = ({
  registrationForm,
  setRegistrationForm,
  handleRegistrationFormChange,
  personalAddress,
  setPersonalAddress,
  handleSubmit,
  agreedCheckbox,
  setAgreedCheckbox,
  formComplete,
  loading,
}) => {
  const { firstName, lastName, agencyName, personalEmail, personalPhone, personalWebsite } = registrationForm
  const { address1, address2, city, state, zipCode } = personalAddress

  const [profilePic, setProfilePic] = useState(null)
  const [errorTree, setErrorTree] = useState({
    firstName: false,
    lastName: false,
    phoneNumber: false,
    personalEmail: false,
    personalWebsite: false,
    zipCode: false,
    agreeToTerms: false,
  })

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  useEffect(() => {
    if (zipCode === '' && !state) return setErrorTree((prev) => ({ ...prev, zipCode: false }))
    if (zipCode !== '' && zipCode.length < 5) {
      setErrorTree((prev) => ({ ...prev, zipCode: true }))
      return
    }
    const validateZipCode = () => {
      const statesArr = whichStates(zipCode)
      if (statesArr.findIndex((s) => s === state) === -1) {
        setErrorTree((prev) => ({ ...prev, zipCode: true }))
        return
      }

      console.log({ state })
      const targetCodes = getZipCodes(state)
      setErrorTree((prev) => ({
        ...prev,
        zipCode: targetCodes.findIndex((c) => c === zipCode) === -1,
      }))
    }
    if (state) {
      validateZipCode()
    }
  }, [state, zipCode])

  const handleSubmitButton = () => {
    handleSubmit()
  }

  const handleImageUploading = async (e) => {
    if (!e.target.files || e.target.files.length <= 0) return
    const file = e.target.files[0]
    setProfilePic(URL.createObjectURL(file))

    // TODO: uncomment this after `getPresigned` api is deployed
    // const imageName = encodeURIComponent(file.name);
    // const fileName = generateUniqueFileName(imageName);

    // const input = {
    //   prsCode: '3209254', // dummy prs code
    //   fileName,
    //   fileType: file.type,
    // };
    // const res = await dispatch(getPresignedUrl(input));
    // const { data: parsedData } = res;
    // if (!parsedData) return;

    // const blobForm = new FormData();
    // Object.entries({ ...parsedData.fields, file }).forEach(([key, value]) => {
    //   blobForm.append(key, value);
    // });
    // await axios.post(parsedData.url, blobForm);

    // setRegistrationForm((prev) => ({
    //   ...prev,
    //   profilePhoto: `${parsedData.url}/${fileName}`,
    // }));
  }

  const handleBlur = ({ target: { name, value } }) => {
    switch (name) {
      case 'firstName':
      case 'lastName':
        if (value === '') {
          setErrorTree({ ...errorTree, [name]: true })
        }
        break
      case 'personalPhone':
        setErrorTree((prev) => ({
          ...prev,
          phoneNumber: value === '' ? false : !isValidPhoneNumber(value),
        }))
        break
      case 'personalEmail':
        setErrorTree((prev) => ({
          ...prev,
          personalEmail: personalEmail === '' ? false : !isValidEmail(value),
        }))
        break
      case 'personalWebsite':
        setErrorTree((prev) => ({
          ...prev,
          personalWebsite: value === '' ? false : !isValidUrl(value),
        }))
        break
      default:
        break
    }
  }

  const errorFree = Object.values(errorTree).every((v) => v === false)

  return (
    <Box width={'100%'}>
      <Typography color="#00314D" fontSize={'16px'} mb={2} textAlign={'start'}>
        Information about you
      </Typography>
      <Grid container spacing={3} justifyContent={'flex-start'} alignItems={'flex-start'}>
        <Grid item xs={12} md={3}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#E8EBF1',
                border: '1px solid #CBD2DB',
                height: { xs: '124px', sm: '86px' },
                width: { xs: '124px', sm: '86px' },
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: isMobile ? '0' : '5px',
              }}
            >
              {profilePic ? (
                <img
                  src={profilePic}
                  alt="Profile preview"
                  style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                />
              ) : (
                <AddAPhotoIcon sx={{ color: '#7B8A9E', height: '40%', width: '40%' }}></AddAPhotoIcon>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          <Box
            width={'100%'}
            pl={0}
            display={'flex'}
            flexDirection={'column'}
            alignItems={isMobile ? 'center' : 'flex-start'}
            gap={'21px'}
          >
            <Button
              sx={{
                textTransform: 'none',
                width: { md: '40%', xs: '35%' },
                height: '40px',
                backgroundColor: '#3C4FB9',
                color: 'white',
                borderRadius: '100px',
                mt: '10px',
                '&:hover': {
                  backgroundColor: '#9BA5DF',
                  color: '#36414E',
                },
                '&:disabled': {
                  backgroundColor: '#C4CAF1',
                  color: 'white',
                  textTransform: 'none',
                },
                align: 'center',
              }}
              component={'label'}
            >
              Upload Photo
              <input name="profilePhoto" type="file" accept="image/*" onChange={handleImageUploading} hidden />
            </Button>
            <Typography
              sx={{
                fontSize: '12px',
                color: '#202020',
                fontWeight: '400',
              }}
            >
              At least 110 x 110 px JPG or PNG file
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              className="white-box"
              placeholder="ex. First name"
              label="First Name"
              value={firstName}
              name="firstName"
              onBlur={handleBlur}
              error={errorTree.firstName}
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              // focused={firstName !== ""}
            />
          </FormControl>
          {errorTree.firstName && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  First Name is required
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. Last name"
              label="Last Name"
              value={lastName}
              name="lastName"
              onBlur={handleBlur}
              error={errorTree.lastName}
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              // focused={lastName !== ""}
            />
          </FormControl>

          {errorTree.lastName && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Last Name is required
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            InputLabelProps={{
              shrink: true,
              sx: {
                '&.MuiInputLabel-shrink': {
                  backgroundColor: '#F5F7FF',
                },
              },
            }}
            placeholder="ex. H.U. LLC"
            label="Agency Name"
            value={agencyName}
            name="agencyName"
            onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
            // focused={producerNumber !== ""}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography color="#00314D" fontSize={'16px'} mb={2} textAlign={'start'}>
            Contact Information
          </Typography>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. email@email.com"
              className="white-box"
              label="Personal Email Address"
              value={personalEmail}
              name="personalEmail"
              type="email"
              onBlur={handleBlur}
              error={errorTree.personalEmail}
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              // focused={workEmail !== ""}
            />
          </FormControl>
          {errorTree.personalEmail && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Please enter a valid email address
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. 000-000-0000"
              className="white-box"
              label="Personal Phone Number"
              value={personalPhone}
              name="personalPhone"
              type="number"
              onBlur={handleBlur}
              error={errorTree.phoneNumber}
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              // focused={workEmail !== ""}
            />
          </FormControl>
          {errorTree.phoneNumber && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Please enter a valid phone number
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. www.mywebsite.com"
              className="white-box"
              label="Personal Website"
              value={personalWebsite}
              name="personalWebsite"
              type="url"
              onBlur={handleBlur}
              error={errorTree.personalWebsite}
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              // focused={workEmail !== ""}
            />
          </FormControl>
          {errorTree.personalWebsite && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Please enter a valid website url
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography color="#00314D" fontSize={'16px'} mb={2} textAlign={'start'}>
            Home Address
          </Typography>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. 00000"
              label="Zip Code"
              name="zipCode"
              value={zipCode}
              type="number"
              onChange={(e) => setPersonalAddress({ ...personalAddress, [e.target.name]: e.target.value })}
              inputProps={{ maxLength: 5 }}
            />
          </FormControl>
          {errorTree.zipCode && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Invalid zip code
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            InputLabelProps={{
              shrink: true,
              sx: {
                '&.MuiInputLabel-shrink': {
                  backgroundColor: '#F5F7FF',
                },
              },
            }}
            placeholder="ex. 123 Main St"
            className="white-box"
            label="Address 1"
            fullWidth
            name="address1"
            value={address1}
            onChange={(e) => setPersonalAddress({ ...personalAddress, [e.target.name]: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            InputLabelProps={{
              shrink: true,
              sx: {
                '&.MuiInputLabel-shrink': {
                  backgroundColor: '#F5F7FF',
                },
              },
            }}
            placeholder="ex. apt. 1A"
            className="white-box"
            label="Address 2"
            fullWidth
            name="address2"
            value={address2}
            onChange={(e) => setPersonalAddress({ ...personalAddress, [e.target.name]: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            InputLabelProps={{
              shrink: true,
              sx: {
                '&.MuiInputLabel-shrink': {
                  backgroundColor: '#F5F7FF',
                },
              },
            }}
            placeholder="ex. City"
            className="white-box"
            label="City"
            fullWidth
            name="city"
            value={city}
            onChange={(e) => setPersonalAddress({ ...personalAddress, [e.target.name]: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            select
            InputLabelProps={{
              shrink: true,
              sx: {
                '&.MuiInputLabel-shrink': {
                  backgroundColor: '#F5F7FF',
                },
              },
            }}
            className="white-box"
            label="State"
            fullWidth
            name="state"
            value={state}
            onChange={(e) => setPersonalAddress({ ...personalAddress, [e.target.name]: e.target.value })}
          >
            <MenuItem value={null} defaultChecked>
              Select State
            </MenuItem>
            {states.map((state, index) => (
              <MenuItem key={index} value={state}>
                {state}
              </MenuItem>
            ))}
          </StyledTextField>
        </Grid>
        {!isMobile && (
          <Grid item xs={12}>
            <Box width={'100%'} gap={'1px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
              <Checkbox
                label="terms-check"
                required
                checked={agreedCheckbox}
                onClick={() => {
                  setAgreedCheckbox(!agreedCheckbox)
                  setErrorTree({
                    ...errorTree,
                    agreeToTerms: !!agreedCheckbox,
                  })
                }}
              />
              <Typography fontSize={'14px'}>
                I agree to the{' '}
                <a href="https://www.afficiency.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="https://www.afficiency.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
              </Typography>
            </Box>
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            sx={{
              textTransform: 'none',
              width: { lg: '40%', md: '50%', sm: '50%', xs: '60%' },
              height: '40px',
              backgroundColor: '#3C4FB9',
              color: 'white',
              borderRadius: '100px',
              mt: '10px',
              '&:hover': {
                backgroundColor: '#9BA5DF',
                color: '#36414E',
              },
              '&:disabled': {
                backgroundColor: '#C4CAF1',
                color: 'white',
                textTransform: 'none',
              },
            }}
            onClick={handleSubmitButton}
            disabled={!errorFree || !agreedCheckbox || !formComplete || loading}
          >
            {loading ? <CircularProgress size={'1.2rem'} /> : isMobile ? 'Done' : 'Create Account'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ThirdRegisterStepV2
